import styled from 'styled-components';

export const CheckboxContainer = styled.div`
  display: flex;
  gap: 30px;
  align-items: center;
  margin-bottom: 15px;
`;
